module.exports = __webpack_public_path__ + "static/media/tv.f4b7afec.svg";